import React, { useState } from "react";
import "./AddAppModal.css";

function AddAppModal({ isOpen, onClose, onSubmit, categories = [] }) {
  const [appName, setAppName] = useState("");
  const [category, setCategory] = useState(categories[0] || "Work apps");
  const [logo, setLogo] = useState("Slack");

  const logoOptions = [
    { name: "Slack", label: "Slack" },
    { name: "Jira", label: "Jira" },
    { name: "Gmail", label: "Gmail" },
    { name: "Drive", label: "Google Drive" },
    { name: "Drivers Portal", label: "Driver Portal" },
    { name: "Autocab", label: "Autocab (DG)" },
    { name: "Nudg", label: "Nudg" },
    { name: "Default", label: "Generic App" }
  ];

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!appName.trim()) return;

    onSubmit({
      name: appName,
      category,
      logo,
      isFavorite: category.toLowerCase().includes("favorite")
    });

    // Reset Form
    setAppName("");
    setCategory(categories[0] || "Work apps");
    setLogo("Slack");
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container glass-card" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="modal-header">
          <h2 className="modal-title">Add New App</h2>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close modal">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Modal Form */}
        <form onSubmit={handleSubmit} className="modal-form">
          {/* App Name */}
          <div className="form-group">
            <label className="form-label" htmlFor="appName">App Name</label>
            <input
              id="appName"
              type="text"
              className="form-input"
              placeholder="e.g., Drivers Portal"
              value={appName}
              onChange={(e) => setAppName(e.target.value)}
              required
              autoFocus
            />
          </div>

          {/* Category */}
          <div className="form-group">
            <label className="form-label" htmlFor="category">Category</label>
            <select
              id="category"
              className="form-select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {categories.map((cat, idx) => (
                <option key={idx} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          {/* Logo Selection */}
          <div className="form-group">
            <label className="form-label">Select App Logo</label>
            <div className="logo-grid">
              {logoOptions.map((opt) => (
                <button
                  key={opt.name}
                  type="button"
                  className={`logo-option-card ${logo === opt.name ? "selected" : ""}`}
                  onClick={() => setLogo(opt.name)}
                >
                  <div className={`logo-option-dot logo-option-dot--${opt.name.toLowerCase().replace(/\s+/g, "-")}`} />
                  <span className="logo-option-label">{opt.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="modal-actions">
            <button type="button" className="modal-btn modal-btn--secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="modal-btn modal-btn--primary">
              Create App
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAppModal;
